export class SuggestedSubtype {
  constructor(
    public subtype: string,
    public email: string,
    public description = '',
    public id = '',
    public uid = ''
  ) {}
}
